import axios from 'axios';
import { Component } from "react";
import { NavLink } from 'react-router-dom';
import Logo from '../images/logo-min.png';
import { loadTree } from '../menuTreeHelper';
import { hasPermission } from "../utils/usePermission";
export default class SidebarAdmin extends Component {

  constructor(props) {
    super(props);
    this.state = {
      expenseCount: 0,
      leaveCount: 0,
      user: {},
    }
  }

  componentDidMount() {
    let userData = JSON.parse(localStorage.getItem('user'))

    this.setState({ user: userData })

    this.getLeaveCount(userData.id);
    this.getExpenseCount();



    loadTree();
  }

  getExpenseCount = async () => {
    try {
      const token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.get(`/expenseHeader/pending-expense-count`, { headers });

      this.setState({ expenseCount: response.data.count })
    } catch (error) {
      console.error("Failed to fetch expense count:", error);
      throw error;
    }
  };

  getLeaveCount = async (id) => {
    try {

      const token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.get(`/applications/reportees/pending-count/${id}`, { headers });

      this.setState({ leaveCount: response.data.count })
    } catch (error) {
      console.error("Failed to fetch expense count:", error);
      throw error;
    }
  };

  render() {
    return (
      <aside className={`main-sidebar sidebar-primary elevation-4 sidebar_padding_bottom_new ${this.props.isSidebarOpen ? 'open' : ''}`} style={{ backgroundColor: 'rgba(2, 42, 90)' }}>
        {/* Brand Logo */}
        <a href="/" className="brand-link">
          <span className="brand-text font-weight-light ml-1">
            <img src={Logo} alt="broken" className="logo-sidebar" height={50} width={50} />
          </span>
        </a>
        {/* Sidebar */}
        <div className="sidebar sidebar-padding-right">
          {/* Sidebar user panel (optional) */}
          <div className="user-panel d-flex">
            <div className="image">
              <img
                src={process.env.PUBLIC_URL + '/user-64.png'}
                className="img-circle elevation-2"
                alt="broken"
                height={40}
                width={40}
              />
            </div>
            <div className="info-sidebar">
              <p className="d-block user_name" >
                {this.state.user.fullname}
              </p>
            </div>
          </div>
          {/* Sidebar Menu */}
          <nav className="mt-0">
            <ul
              className="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              {/* Add icons to the links using the .nav-icon class
         with font-awesome or any other icon font library */}
              {hasPermission('Dash') && (
                <li className="nav-item">
                  <NavLink exact to="/" className="nav-link">
                    <i className="nav-icon fas fa-tachometer-alt" />
                    <p>
                      Dashboard
                      <span className="right badge badge-success">Home</span>
                    </p>
                  </NavLink>
                </li>
              )}

              <li className="nav-item has-treeview">
                {hasPermission('M17') && (
                  <NavLink to="/fake-url" className="nav-link" activeClassName="nav-link">
                    <i className="nav-icon fas fa-database" />
                    <p>
                      Master Data
                      <i className="right fas fa-angle-left" />
                    </p>
                  </NavLink>
                )}
                <ul className="nav nav-treeview">
                  {hasPermission('M17S1') &&
                    (<li className="nav-item">
                      <NavLink to="/UOMList" className="nav-link">
                        <i className=" fa fas fa-list-ul nav-icon " />
                        <p>UOM List</p>
                      </NavLink>
                    </li>)
                  }
                  {hasPermission('M17S2') && (
                    <li className="nav-item">
                      <NavLink to="/ItemList" className="nav-link">
                        <i className="fas fa-box nav-icon" />
                        <p>Items List</p>
                      </NavLink>
                    </li>
                  )}

                  {hasPermission('M17S3') &&
                    (<li className="nav-item">
                      <NavLink to="/LabourList" className="nav-link">
                        <i className="fas fa-user nav-icon " />
                        <p>Labour Codes List</p>
                      </NavLink>
                    </li>)
                  }
                  {hasPermission('M17S4') && (
                    <li className="nav-item">
                      <NavLink to="/ConsumableItemList" className="nav-link">
                        <i className="fas fa-tools nav-icon" />
                        <p>Consumable Items List</p>
                      </NavLink>
                    </li>
                  )}

                </ul>
              </li>

              <li className="nav-item has-treeview">
                {
                  hasPermission("M1") && (
                    <NavLink to="/fake-url" className="nav-link" activeClassName="nav-link">
                      <i className="nav-icon fas fa-user-cog" />
                      <p>
                        Roles
                        <i className="right fas fa-angle-left" />
                      </p>
                    </NavLink>
                  )
                }
                <ul className="nav nav-treeview">
                  {hasPermission('M1S1') && (
                    <li className="nav-item">
                      <NavLink to="/role-add" className="nav-link">
                        <i className="fa 	fas fa-user-plus nav-icon" />
                        <p>Add Role</p>
                      </NavLink>
                    </li>
                  )}
                  {hasPermission('M1S2') && (
                    <li className="nav-item">
                      <NavLink to="/role-list" className="nav-link">
                        <i className="fas fa-list-ul nav-icon" />
                        <p>Role List</p>
                      </NavLink>
                    </li>
                  )}
                </ul>
              </li>
              <li className="nav-item has-treeview">
                {hasPermission('M2') && (
                  <NavLink to="/fake-url" className="nav-link" activeClassName="nav-link">
                    <i className="nav-icon fas fa-user-lock" />
                    <p>
                      Permission Codes
                      <i className="right fas fa-angle-left" />
                    </p>
                  </NavLink>
                )}
                <ul className="nav nav-treeview">
                  {hasPermission('M2S1') &&
                    (<li className="nav-item">
                      <NavLink to="/permission-code-add" className="nav-link">
                        <i className=" fa fas fa-lock nav-icon " />
                        <p>Add Permission</p>
                      </NavLink>
                    </li>)
                  }
                  {hasPermission('M2S2') && (
                    <li className="nav-item">
                      <NavLink to="/permission-code-list" className="nav-link">
                        <i className="fas fa-list-ul nav-icon" />
                        <p>Permission Code List</p>
                      </NavLink>
                    </li>
                  )}

                </ul>
              </li>
              {hasPermission('M3') && (
                <li className="nav-item">
                  <NavLink exact to="/departments" className="nav-link">
                    <i className="nav-icon fa fa-building" />
                    <p>
                      Departments
                    </p>
                  </NavLink>
                </li>
              )}
              <li className="nav-item has-treeview">
                {hasPermission("M4") && (
                  <NavLink to="/fake-url" className="nav-link" activeClassName="nav-link">
                    <i className="nav-icon fa fa-user" />
                    <p>
                      Customers
                      <i className="right fas fa-angle-left" />
                    </p>
                  </NavLink>
                )}

                <ul className="nav nav-treeview">
                  {hasPermission("M4S1") && (
                    <li className="nav-item">
                      <NavLink to="/customer-add" className="nav-link">
                        <i className="fa 	fas fa-user-plus nav-icon" />
                        <p>Add Customer</p>
                      </NavLink>
                    </li>
                  )}
                  {hasPermission("M4S2") && (
                    <li>
                      <NavLink to="/customer-list" className="nav-link">
                        <i className="fas fa-list-ul nav-icon" />
                        <p>Customer List</p>
                      </NavLink>
                    </li>
                  )}

                </ul>
              </li>
              <li className="nav-item has-treeview">
                {hasPermission("M5") && (
                  <NavLink to="/fake-url" className="nav-link" activeClassName="nav-link">
                    <i className="nav-icon fa fa-balance-scale" />
                    <p>
                      Vendors
                      <i className="right fas fa-angle-left" />
                    </p>
                  </NavLink>
                )}
                <ul className="nav nav-treeview">
                  {hasPermission('M5S1') && (
                    <li className="nav-item">
                      <NavLink to="/vendor-add" className="nav-link">
                        <i className="fa fa-balance-scale nav-icon" />
                        <p>Add Vendor</p>
                      </NavLink>
                    </li>
                  )}
                  {hasPermission("M5S2") && (
                    <li className="nav-item">
                      <NavLink to="/vendor-list" className="nav-link">
                        <i className="fas fa-list-ul nav-icon" />
                        <p>Vendor List</p>
                      </NavLink>
                    </li>
                  )}
                </ul>
              </li>
              <li className="nav-item has-treeview">
                {hasPermission('M6') && (
                  <NavLink to="/fake-url" className="nav-link" activeClassName="nav-link">
                    <i className="nav-icon fa fa-project-diagram" />
                    <p>
                      Projects
                      <i className="right fas fa-angle-left" />
                    </p>
                  </NavLink>
                )}

                <ul className="nav nav-treeview">
                  {hasPermission('M6S1') && (
                    <li className="nav-item">
                      <NavLink to="/project-add" className="nav-link">
                        <i className="fa fa-project-diagram nav-icon" />
                        <p>Add Project</p>
                      </NavLink>
                    </li>
                  )}
                  {hasPermission('M6S2') && (
                    <li className="nav-item">
                      <NavLink to="/project-list" className="nav-link">
                        <i className="fas fa-list-ul nav-icon" />
                        <p>Project List</p>
                      </NavLink>
                    </li>
                  )}

                </ul>
              </li>
              <li className="nav-item has-treeview">
                {hasPermission('M7') && (
                  <NavLink to="/fake-url" className="nav-link" activeClassName="nav-link">
                    <i className="nav-icon fa fa-user" />
                    <p>
                      Employee
                      <i className="right fas fa-angle-left" />
                    </p>
                  </NavLink>
                )}
                <ul className="nav nav-treeview">
                  {hasPermission('M7S1') && (
                    <li className="nav-item">
                      <NavLink to="/employee-add" className="nav-link">
                        <i className="fa fa-user-plus nav-icon" />
                        <p>Add Employee</p>
                      </NavLink>
                    </li>
                  )}
                  {hasPermission('M7S2') && (
                    <li className="nav-item">
                      <NavLink to="/employee-list" className="nav-link">
                        <i className="fas fa-users nav-icon" />
                        <p>Employee List</p>
                      </NavLink>
                    </li>
                  )}
                  {hasPermission('M7S3') && (
                    <li className="nav-item">
                      <NavLink to="/exit-employee-list" className="nav-link">
                        <i className="fas fa-users nav-icon" />
                        <p>Exit Employee List</p>
                      </NavLink>
                    </li>
                  )}
                </ul>
              </li>
              <li className="nav-item">
                {hasPermission('M8') && (
                  <NavLink to="/job-list" className="nav-link">
                    <i className="nav-icon fas fa-briefcase" />
                    <p>
                      Job List
                    </p>
                  </NavLink>
                )}

              </li>
              <li className="nav-item has-treeview">
                {hasPermission('M9') && (
                  <NavLink to="/fake-url" className="nav-link d-flex align-items-center justify-content-between" activeClassName="nav-link">
                    <i className="nav-icon fa fa-rocket" />
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <span>
                        Leaves <span className="badge-danger badge-circle">{this.state.leaveCount}</span>
                      </span>
                      <i className="fas fa-angle-left" />
                    </div>
                  </NavLink>
                )}
                <ul className="nav nav-treeview">
                  {hasPermission('M9S1') && (
                    <li className="nav-item">
                      <NavLink to="/application" className="nav-link">
                        <i className="fa fa-plus nav-icon" />
                        <p>Add Leave</p>
                      </NavLink>
                    </li>
                  )}
                  {hasPermission('M9S2') && (
                    <li className="nav-item">
                      <NavLink to="/application-list" className="nav-link">
                        <i className="fas fa-list-ul nav-icon" />
                        <p>Leave list</p>
                      </NavLink>
                    </li>
                  )}
                </ul>
              </li>
              <li className="nav-item has-treeview">
                {hasPermission('M10') && (
                  <NavLink to="/fake-url" className="nav-link" activeClassName="nav-link">
                    <i className="nav-icon fas fa-rupee-sign" />
                    <p>
                      Payroll Management
                      <i className="right fas fa-angle-left" />
                    </p>
                  </NavLink>
                )}

                <ul className="nav nav-treeview">
                  {/* <li className="nav-item">
                    <NavLink to="/salary-details" className="nav-link">
                      <i className="fas fa-rupee-sign nav-icon" />
                      <p>Manage Salary Details</p>
                    </NavLink>
                  </li> */}
                  {hasPermission('M10S1') && (
                    <li className="nav-item">
                      <NavLink to="/salary-list" className="nav-link">
                        <i className="fas fa-users nav-icon" />
                        <p>Employee Salary List</p>
                      </NavLink>
                    </li>
                  )}

                  {/* <li className="nav-item">
                    <NavLink to="/payment" className="nav-link">
                      <i className="fas fa-money-check nav-icon" />
                      <p>Make Payment</p>
                    </NavLink>
                  </li> */}
                  {hasPermission('M10S2') && (
                    <li className="nav-item">
                      <NavLink to="/monthly-salary" className="nav-link">
                        <i className="fas fa-money-check nav-icon" />
                        <p>Monthly Salary</p>
                      </NavLink>
                    </li>
                  )}
                  {hasPermission('M10S3') && (
                    <li className="nav-item">
                      <NavLink to="/ot-list" className="nav-link">
                        <i className="fas fa-money-check nav-icon" />
                        <p>OT List</p>
                      </NavLink>
                    </li>
                  )}
                </ul>
              </li>
              {hasPermission('M11') && (
                <li className="nav-item">
                  <NavLink to="/attendance-list" className="nav-link">
                    <i className="nav-icon fas fa-clock" />
                    <p>
                      Attendance
                    </p>
                  </NavLink>
                </li>
              )}

              {/* Start Advance payment  */}
              <li className="nav-item has-treeview">
                {hasPermission('M12') && (
                  <NavLink to="/fake-url" className="nav-link" activeClassName="nav-link">
                    <i className="nav-icon fas fa-rupee-sign" />
                    <p>
                      Advance payment
                      <i className="right fas fa-angle-left" />
                    </p>
                  </NavLink>
                )}

                <ul className="nav nav-treeview">
                  {hasPermission("M12S1") && (
                    <li className="nav-item">
                      <NavLink to="/advance-pay-add" className="nav-link">
                        <i className="fas fa-rupee-sign nav-icon" />
                        <p>Add Advance payment</p>
                      </NavLink>
                    </li>
                  )}
                  {hasPermission('M12S2') && (
                    <li className="nav-item">
                      <NavLink to="/advance-pay-list" className="nav-link">
                        <i className="fas fa-list-ul nav-icon" />
                        <p>Advance payment List</p>
                      </NavLink>
                    </li>
                  )}

                </ul>
              </li>
              {/* End Advance payment  */}
              {/* start Fine  */}
              <li className="nav-item has-treeview">
                {hasPermission('M13') && (
                  <NavLink to="/fake-url" className="nav-link" activeClassName="nav-link">
                    <i className="nav-icon fas fa-gavel" />
                    <p>
                      Fine
                      <i className="right fas fa-angle-left" />
                    </p>
                  </NavLink>
                )}

                <ul className="nav nav-treeview">
                  {hasPermission('M13S1') && (
                    <li className="nav-item">
                      <NavLink to="/fine-add" className="nav-link">
                        <i className="fas fa-gavel nav-icon" />
                        <p>Add Fine</p>
                      </NavLink>
                    </li>
                  )}
                  {hasPermission('M13S2') && (
                    <li className="nav-item">
                      <NavLink to="/fine-list" className="nav-link">
                        <i className="fas fa-list-ul nav-icon" />
                        <p>Fine List</p>
                      </NavLink>
                    </li>
                  )}
                </ul>
              </li>
              {/* End Fine  */}
              {/* start */}
              <li className="nav-item has-treeview">
                {hasPermission('M14') && (
                  <NavLink to="/fake-url" className="nav-link" activeClassName="nav-link">
                    <i className="nav-icon fas fa-money-bill" />
                    <p>
                      Expense category
                      <i className="right fas fa-angle-left" />
                    </p>
                  </NavLink>
                )}

                <ul className="nav nav-treeview">
                  {hasPermission('M14S1') && (
                    <li className="nav-item">
                      <NavLink to="/add-expense-category" className="nav-link">
                        <i className="fas fa-folder-plus nav-icon" />
                        <p>Add category</p>
                      </NavLink>
                    </li>
                  )}
                  {hasPermission('M14S2') && (
                    <li className="nav-item">
                      <NavLink to="/expense-category-list" className="nav-link">
                        <i className="fas fa-file-invoice nav-icon" />
                        <p>Category List</p>
                      </NavLink>
                    </li>
                  )}
                </ul>
              </li>
              {/* end */}

              <li className="nav-item has-treeview">
                {hasPermission('M15') && (
                  <NavLink to="/fake-url" className="nav-link d-flex align-items-center justify-content-between" activeClassName="nav-link">

                    <i className="nav-icon fas fa-money-bill" />
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <span>
                        Expense Management  <span className="badge-danger badge-circle">{this.state.expenseCount}</span>
                      </span>
                      <i className="fas fa-angle-left" />
                    </div>
                  </NavLink>
                )}
                <ul className="nav nav-treeview">
                  {hasPermission('M15S1') && (
                    <li className="nav-item">
                      <NavLink to="/add-expense-header" className="nav-link">
                        <i className="fas fa-plus-circle nav-icon" />
                        <p> Add Expense Header</p>
                      </NavLink>
                    </li>
                  )}
                  {hasPermission('M15S2') && (
                    <li className="nav-item">
                      <NavLink to="/expense-header-list" className="nav-link">
                        <i className="fas fa-shopping-cart nav-icon" />
                        <p>Expense Header List</p>
                      </NavLink>
                    </li>
                  )}
                  {/* {hasPermission('M15S3') && (
                    <li className="nav-item">
                      <NavLink to="/expense-list" className="nav-link">
                        <i className="fas fas fa-file-invoice nav-icon" />
                        <p>Expense List</p>
                      </NavLink>
                    </li>
                  )} */}

                  {/* <li className="nav-item">
                    <NavLink to="/add-expense" className="nav-link">
                      <i className="fas fa-wallet nav-icon" />
                      <p>Add Expense</p>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to="/expense-list" className="nav-link">
                      <i className="fas fa-wallet nav-icon" />
                      <p>Expense List</p>
                    </NavLink>
                  </li> */}
                  {/* <li className="nav-item">
                    <NavLink to="/expense" className="nav-link">
                      <i className="fas fa-shopping-cart nav-icon" />
                      <p>Make Expense</p>
                    </NavLink>
                  </li>

                  <li className="nav-item">
                    <NavLink to="/expense-report" className="nav-link">
                      <i className="fas fa-file-invoice nav-icon" />
                      <p>Expense Report</p>
                    </NavLink>
                  </li> */}
                </ul>
              </li>
              {hasPermission('M16') && (
                <li className="nav-item">
                  <NavLink exact to="/announcement" className="nav-link">
                    <i className="nav-icon fa fa-bell" />
                    <p>
                      Announcements
                    </p>
                  </NavLink>
                </li>
              )}
              {hasPermission('M18') && (
                <li className="nav-item">
                  <NavLink exact to="/PurchaseOrderList" className="nav-link">
                    <i className="nav-icon fa fa-shopping-cart " />
                    <p>
                      Purchase Order
                    </p>
                  </NavLink>
                </li>
              )}
              {hasPermission('M19') && (
                <li className="nav-item">
                  <NavLink exact to="/DeliveryChallanList" className="nav-link">
                    <i className="nav-icon fas fa-dolly" />
                    <p>
                      Delivery Challan
                    </p>
                  </NavLink>
                </li>
              )}
              {hasPermission('M20') && (
                <li className="nav-item">
                  <NavLink exact to="/vendor-work-order-list" className="nav-link">
                    <i className="nav-icon fas fa-file-invoice" />
                    <p>
                      Vendor Work Order
                    </p>
                  </NavLink>
                </li>
              )}
              {hasPermission('M21') && (
                <li className="nav-item">
                  <NavLink exact to="/work-order" className="nav-link">
                    <i className="nav-icon fas fa-file-invoice" />
                    <p>
                      Work Order
                    </p>
                  </NavLink>
                </li>
              )}
              {hasPermission('M22') && (
                <li className="nav-item">
                  <NavLink exact to="/measurement-bill" className="nav-link">
                    <i className="nav-icon fas fa-receipt" />
                    <p>
                      Measurement Bill
                    </p>
                  </NavLink>
                </li>
              )}
            </ul>
          </nav>
        </div>
      </aside >
    );
  }
}
